import { render, staticRenderFns } from "./StylizedSubmitButton.vue?vue&type=template&id=508e6673&scoped=true&"
import script from "./StylizedSubmitButton.vue?vue&type=script&lang=js&"
export * from "./StylizedSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./StylizedSubmitButton.vue?vue&type=style&index=0&id=508e6673&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e6673",
  null
  
)

export default component.exports